import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deliverycardHeadline: {
    id: 'delivery.delivery-card.headline',
    defaultMessage: 'Lieferinformationen',
  },
});
